// extracted by mini-css-extract-plugin
export default {"form-padding":"40","formPadding":"40","form-padding-mobile":"16","formPaddingMobile":"16","grid-bottom":"grid-bottom--ygi5Z","gridBottom":"grid-bottom--ygi5Z"};